// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getInvoiceAgingSummary } from '@/billing/api/get-invoice-aging-summary';
import { TWO_MINUTES_MS } from '@/utilities/time-constants';
import { useQuery } from '@tanstack/react-query';

// Fetches the 5-bucket aging summary for the A/R aging report's cards.
// Kept on its own query key (`['invoice-summary', 'aging']`) so the table
// can paginate or refetch without churning the cards. `summary` is null
// while the first fetch is in flight — callers must render a skeleton
// instead of fabricating zeros.
export function useInvoiceAgingSummary() {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['invoice-summary', 'aging'],
    queryFn: getInvoiceAgingSummary,
    refetchOnWindowFocus: true,
    refetchInterval: TWO_MINUTES_MS,
  });

  return {
    summary: data ?? null,
    isLoading,
    isFetching,
  };
}
